import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react'

import { ConnectionI } from '../../types/types'
import { CameraIcon, getDeviceIcon } from '../../utils/DeviceIcons'
import { getPopOverTitle } from '../utils/utils'
import { TailgatePopoverBody } from './TailgatePopoverBody'

interface TailgatePopoverContentIProps {
  deviceName: string
  cameraName: string
  connection: ConnectionI
}

export const TailgatePopoverContent = ({
  deviceName,
  cameraName,
  connection,
}: TailgatePopoverContentIProps) => {
  const title = getPopOverTitle(connection)
  const icon = getDeviceIcon(connection?.deviceType)
  return (
    <Box p='16px'>
      <Flex direction='column' marginBottom='16px'>
        <Text fontSize='14px' fontWeight='medium' whiteSpace='pre-line'>
          {title}
        </Text>

        <TailgatePopoverBody connection={connection} />
      </Flex>
      <VStack alignItems='flex-start' pos='relative' spacing='14px'>
        <HStack>
          <CameraIcon />
          <Text fontSize='12px'>{cameraName}</Text>
        </HStack>
        <Box paddingLeft='12px' pos='absolute' top='16px'>
          <img src='/TailgateConnectedIcon.svg' />
        </Box>
        <HStack>
          {icon}
          <Text fontSize='12px'>{deviceName}</Text>
        </HStack>
      </VStack>
    </Box>
  )
}
